import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/all-styles.css'
import './styles/global.css'
import App from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
